var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.prepareColor(_vm.item)}},'v-icon',attrs,false),on),[_vm._v(" mdi-calendar-month-outline ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.prepareInfo(_vm.item)))])])}
var staticRenderFns = []

export { render, staticRenderFns }